import { Controller } from "react-hook-form";
import { Box, Typography, Button } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { useTranslation } from "react-i18next";
 

interface Props {
  name: string;
  control: any;
  label?: string;
  rules?: any;
  accept?: string;
}

const FormFileInput = ({
  name,
  control,
  label,
  rules,
  accept = ".pdf,.doc,.docx,.jpg,.png"
}: Props) => {

  const {t} = useTranslation()

  

  return (
 <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <Box>
          <Typography sx={{ mb: 1, fontWeight: 500 }}>
            {label}
          </Typography>

          <Box
            sx={{
              border: "2px dashed #d1d5db",
              borderRadius: "10px",
              padding: "20px",
              textAlign: "center",
              // backgroundColor: "#fafafa",
              cursor: "pointer",
              transition: "0.2s",
              "&:hover": {
                borderColor: "primary.main",
                backgroundColor: "#f5f5f5"
              }
            }}
          >
            <input
              type="file"
              accept={accept}
              style={{ display: "none" }}
              id={name}
              onChange={(e: any) => field.onChange(e.target.files[0])}
            />

            <label htmlFor={name}>
              <Button
                component="span"
                startIcon={<UploadFileIcon />}
                variant="contained"
              >
                {t("Choose File")}
              </Button>
            </label>

            {field.value && (
              <Typography
                sx={{
                  mt: 2,
                  fontSize: "14px",
                  color: "text.secondary"
                }}
              >
                {field.value?.name}
              </Typography>
            )}
          </Box>

          {fieldState.error && (
            <Typography color="error" variant="caption">
              {fieldState.error.message}
            </Typography>
          )}
        </Box>
      )}
    />
  );
};

export default FormFileInput;